import { cva, } from 'class-variance-authority';

export { default as Input, } from './Input.vue';

export const inputVariants = cva(
  'block w-full px-3 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
  {
    variants: {
      intent: {
        default: 'summit-black text-sm placeholder-gray-400 bg-white border-gray-300 focus:border-primary-140',
        disabled: 'text-sm border-gray-300 bg-gray-100 placeholder-gray-200 text-gray-900',
        nav: 'placeholder-black border-[1.5px] bg-white mb-3 h-10 w-5 md:w-80 px-5 pr-16 rounded font-bold text-black focus:outline-none focus:ring-primary-140',
        footer: 'placeholder-black border-[1.5px] bg-white mb-3 h-10 w-5 md:w-80 mx-auto text-2xl px-5 pr-16 rounded font-bold text-black focus:outline-none',
        danger: 'border-red-300 bg-red-50 placeholder-red-200 text-red-900',
        success: 'border-green-300 bg-green-50 placeholder-gray-400 text-green-900',
        ceTracker: 'placeholder-black text-sm appearance-none block w-full h-12 text-black font-bold border border-gray-300 rounded px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
